import { http, HttpResponse } from "msw";
import AddClientCampaignModal from "./";
import { useOrbit } from "providers/OrbitProvider";
import { useEffect, useState } from "react";
import { ClientCampaignRecord } from "lib/DataModel";
import { userEvent, screen } from "@storybook/test";
import { mockGetClientMetadata } from "lib/storybook/utils";


export default {
  title: "Components/AddClientCampaignModal",
  component: AddClientCampaignModal,
};

const Template = (args) => <AddClientCampaignModal {...args} />;

export const Default = {
  render: Template,
  args: {
    clientCampaign: { type: 'clientCampaign' },
    clientId: "123",
    contract: {
      type: "contract",
      id: "dbe2b437-d8fc-4a9a-ad24-01cf170eb6a5",
      keys: {
        remoteId: "45",
      },
      relationships: {
        client: {
          data: {
            type: "client",
            id: "123",
          },
        },
        vendor: {
          data: {
            type: "vendor",
            id: "b472d1af-b00a-45fc-a4c8-59f8f449c2b3",
          },
        },
      },
    },
  },
  parameters: {
    msw: {
      handlers: [
        http.get("/api/v1/client-campaigns", () => {
          return HttpResponse.json({
            data: {
              id: "33",
              type: "client-campaigns",
              attributes: {
                name: "Health Exclusive",
                "campaign-type": "exclusive",
                "channel-type": "organic search",
                "billable-lead-count": 808,
                "smart-score": "green",
                "public-id": "00003820",
                "payout": 'cost_per_enroll',
                "custom-attributes": {
                  "LeadSource": "CYGSOC",
                },
              },
              relationships: {
                contract: {
                  data: {
                    id: "45",
                    type: "contracts",
                  },
                },
                "program-group": {
                  data: {
                    id: "96",
                    type: "program-groups",
                  },
                },
              },
            },
          })
        }),
        http.get("/api/v1/*program-groups", () => {
          return HttpResponse.json({
            data: [
              {
                id: "96",
                type: "program-groups",
                attributes: {
                  id: 96,
                  "client-id": 134,
                  description: "Healthcare Management",
                  "created-at": "2021-04-05T15:05:34.492Z",
                  "updated-at": "2021-04-05T15:05:34.492Z",
                },
                relationships: {
                  client: { data: { id: "134", type: "clients" } },
                },
              },
              {
                id: "97",
                type: "program-groups",
                attributes: {
                  id: 97,
                  "client-id": 134,
                  description: "Master's Programs",
                  "created-at": "2021-04-05T15:05:34.542Z",
                  "updated-at": "2021-04-05T15:05:34.542Z",
                },
                relationships: {
                  client: { data: { id: "134", type: "clients" } },
                },
              },
            ],
          });
        }),
      ],
    },
    providers: {
      apollo: {
        mocks: [
          mockGetClientMetadata(),
        ],
      }
    },
  },
}

export const WithVCPLLeadPricing = {
  ...Default,
  play: async () => {
    userEvent.click(await screen.findByLabelText("Lead Pricing"))
    userEvent.click(await screen.findByText("Variable CPL"))
  },
}

export const WithCustomAttributes = {
  ...Default,
  parameters: {
    ...Default.parameters,
    providers: {
      ...Default.parameters.providers,
      apollo: {
        mocks: [
          mockGetClientMetadata({
            clientIds: ['123'],
            customAttributeDefinitions: [
              { __typename: 'CustomAttributeDefinition', id: '1', entityType: 'client_campaign', key: 'LeadSource' },
              { __typename: 'CustomAttributeDefinition', id: '2', entityType: 'client_campaign', key: 'VendorCode' },
              { __typename: 'CustomAttributeDefinition', id: '3', entityType: 'degree_program', key: 'ThisShouldNotAppear' },
              { __typename: 'CustomAttributeDefinition', id: '4', entityType: 'program_group', key: 'ThisShouldAlsoNotAppear' },
            ],
          }),
        ],
      }
    },
  },
}

export const EditExistingCampaign = {
  ...Default,
  render: args => {
    const { remote } = useOrbit()
    const [clientCampaign, setClientCampaign] = useState<ClientCampaignRecord | null>()
    useEffect(() => {
      remote.query<ClientCampaignRecord>(q => q.findRecord({ type: 'clientCampaign', id: '33' })).then(clientCampaign => {
        setClientCampaign(clientCampaign)
      })
    }, [remote])
    if(clientCampaign) {
      return Default.render({ ...args, clientCampaign })
    } else {
      return <div></div>
    }
  },
}

export const EditExistingCampaignWithCustomAttributes = {
  ...EditExistingCampaign,
  parameters: WithCustomAttributes.parameters,
}
